/* eslint-disable react/button-has-type */
import React, { useState, useRef, useEffect } from 'react';
import { ChevronDown, Check } from 'tabler-icons-react';

const CustomSelect = ({
  options, value, onChange, icon,
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const handleSelect = (option) => {
    onChange(option.value);
    setIsOpen(false);
  };

  const selectedOption = options.find((opt) => opt.value === value) || options[0];

  return (
    <div className="relative inline-block" ref={dropdownRef}>
      {/* Trigger Button */}
      <button
        onClick={() => setIsOpen(!isOpen)}
        className="w-fit h-9 flex items-center gap-2 px-4 py-2.5 bg-[#FAFAFA] dark:bg-[#1a1b1e] border border-[#00000000] dark:border-neutral-600 rounded-lg hover:bg-gray-50 transition-colors focus:outline-none focus:ring-1"
      >
        {icon && <span className="text-[#717182]">{icon}</span>}
        <span className="text-sm font-normal text-[#0A0A0A] dark:text-[#898989] min-w-[78px] text-left">
          {selectedOption.label}
        </span>
        <ChevronDown size={16} color="#717182" className={`transition-transform ${isOpen ? 'rotate-180' : ''}`} />
      </button>

      {/* Dropdown Menu */}
      {isOpen && (
        <div className="absolute top-full left-0 mt-2 w-full bg-white border border-gray-200 dark:border-neutral-600 rounded-lg shadow-lg z-50 overflow-hidden">
          {options.map((option) => (
            <button
              key={option.value}
              onClick={() => handleSelect(option)}
              className="w-full px-3.5 py-1.5 text-left bg-[#FAFAFA] dark:bg-[#1a1b1e] transition-colors flex items-center justify-between group"
            >
              <span className="text-sm font-medium text-[#0A0A0A] dark:text-[#898989]">
                {option.label}
              </span>
              {value === option.value && (
                <Check size={16} color="#717182" />
              )}
            </button>
          ))}
        </div>
      )}
    </div>
  );
};

export default CustomSelect;
